import { IconButton } from '@mui/material';
import { CopyIcon } from '@phosphor-icons/react';

import { useCopyToClipboard } from './useCopyToClipboard.js';

interface CopyToClipboardProps {
  content: string;
  animationVariant?: 'HoverForVisibility' | 'AlwaysVisible';
}

export function CopyToClipboardButton(props: CopyToClipboardProps) {
  const { content, animationVariant = 'HoverForVisibility' } = props;

  const { copyToClipboard } = useCopyToClipboard();
  return (
    <IconButton
      aria-label="Copy to clipboard"
      onClick={() => {
        copyToClipboard(content);
      }}
      size="small"
      sx={
        animationVariant === 'HoverForVisibility'
          ? {
              opacity: 0,
              transition: 'opacity 0.2s',
              '&:hover': {
                opacity: 1,
              },
            }
          : undefined
      }
    >
      <CopyIcon size={16} />
    </IconButton>
  );
}
